/**
 * @file Reads the raw content of a file.
 */

/**
 * Reads a file's full content as an array buffer.
 */
const readFileContent = (file: Blob): Promise<ArrayBuffer> => {
  const promise = new Promise<ArrayBuffer>((resolve) => {
    const reader = new FileReader();

    /**
     * Resolves the promise with the file's content once it loads.
     */
    reader.onload = () => {
      const content = reader.result as ArrayBuffer;

      resolve(content);
    };

    reader.readAsArrayBuffer(file);
  });

  return promise;
};

export default readFileContent;
